import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { api } from '../store/api/api';
import { ThreadExcerpt } from '../components/shelves/ThreadExcerpt';
import { AddCommentDialog } from '../components/shelves/comments/AddCommentDialog';
import {
  selectThreadsByCategory,
  selectThreadsByCategoryKeyword,
  useGetThreadsQuery,
} from '../store/api/threadsApi';
import { useGetUsersQuery } from '../store/api/usersApi';
import { CategoryList } from '../components/pieces/CategoryList';
import { DiscoverPageSkeleton } from '../components/shelves/transitions/DiscoverPageSkeleton';
import { SideJoke } from '../components/shelves/SideJoke';
import { asyncReceiveGeeksJoke } from '../store/plain/geeksJoke/action';

export function Discover() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const params = searchParams.get('category') || '';
  const {
    isUninitialized: threadsNotLoadedYet,
    isLoading: loadingThreads,
    data: threadsData,
    isError: loadingThreadsFailed,
  } = useGetThreadsQuery();
  const {
    isUninitialized: usersNotLoadedYet,
    isLoading: loadingUsers,
    data: users,
    isError: loadingUsersFailed,
  } = useGetUsersQuery();

  const defaultThreads = useSelector((state) =>
    selectThreadsByCategoryKeyword(state, params)
  );

  const [visibleThreads, setVisibleThreads] = useState(
    defaultThreads.sort((a, b) => b.upVotesBy.length - a.upVotesBy.length)
  );

  const filteredThreads = useSelector((state) =>
    selectThreadsByCategory(state, params)
  );

  const sortedThreads = filteredThreads.sort(
    (a, b) => b.upVotesBy.length - a.upVotesBy.length
  );

  const { geeksJoke = [] } = useSelector((state) => state);

  useEffect(() => {
    if (threadsNotLoadedYet) dispatch(api.endpoints.getThreads.initiate());
    if (usersNotLoadedYet) dispatch(api.endpoints.getUsers.initiate());
    if (!geeksJoke) dispatch(asyncReceiveGeeksJoke());

    if (params && params !== '') {
      setVisibleThreads(sortedThreads);
    } else {
      setVisibleThreads(
        defaultThreads.sort((a, b) => b.upVotesBy.length - a.upVotesBy.length)
      );
    }
  }, [
    defaultThreads,
    dispatch,
    geeksJoke,
    params,
    sortedThreads,
    threadsNotLoadedYet,
    usersNotLoadedYet,
  ]);

  return (
    <section className="container mx-auto mt-8 mb-16 max-w-[600px] break-words px-2 2xl:max-w-2xl">
      {loadingThreads && loadingUsers ? <DiscoverPageSkeleton /> : ''}
      {threadsData && users ? (
        <>
          <CategoryList />
          {visibleThreads.length > 0 ? (
            <ul className="mb-10 grid divide-y divide-gray-200 overflow-hidden dark:divide-gray-800">
              {visibleThreads.map((thread) => (
                <li
                  key={thread.id}
                  className="py-2 hover:bg-indigo-500/5 dark:hover:bg-indigo-900/5"
                >
                  <ThreadExcerpt thread={thread} />
                </li>
              ))}
            </ul>
          ) : (
            <div className="grid h-80 place-items-center text-center">
              Threads in this category will appear here <br />
              if available
            </div>
          )}
          <div className="px-3 py-4 lg:hidden">
            {geeksJoke && <SideJoke geeksJoke={geeksJoke} />}
          </div>
        </>
      ) : (
        ''
      )}
      {loadingThreadsFailed || loadingUsersFailed ? (
        <div className="my-4">Nothing to see here</div>
      ) : (
        ''
      )}
      <AddCommentDialog />
    </section>
  );
}
